export const BOOKING_URL = "https://chirolanewellness.janeapp.com";
export const PHONE = "214-814-3929";
export const PHONE_HREF = "tel:+12148143929";
export const EMAIL = "info@chirolanewellness.com";
export const EMAIL_HREF = "mailto:info@chirolanewellness.com";

export const SERVICE_AREAS = [
    "Dallas", "Oak Cliff", "DeSoto", "Red Oak", "Lancaster",
    "Waxahachie", "Grand Prairie", "Arlington", "Mesquite",
];

export const SERVICES = [
    {
        id: "chiropractic-adjustments",
        testid: "service-card-chiropractic",
        title: "Chiropractic Adjustments",
        tagline: "Precise spinal care, tailored to you",
        image: "/assets/chiropractic-adjustment.jpg",
        overview:
            "Gentle hands-on and instrument-assisted spinal adjustments designed to restore alignment, improve joint motion, and calm the nervous system. Every adjustment plan begins with a thorough assessment of how you move.",
        whoFor: ["Neck, back, and hip discomfort", "Headaches and posture strain", "Desk workers and commuters"],
        expect: ["Comprehensive movement assessment", "Personalized adjustment plan", "Progress checks at every visit"],
        benefits: ["Restored range of motion", "Reduced pain and tension", "Better posture and alignment"],
    },
    {
        id: "manual-adjustments",
        testid: "service-card-manual",
        title: "Manual Therapy",
        tagline: "Hands-on techniques for deep release",
        image: "https://images.unsplash.com/photo-1706353399656-210cca727a33?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        overview:
            "Traditional hands-on diversified techniques, soft-tissue work, and mobilization for patients who respond best to manual therapy. Dr. Lane adapts pressure and approach to your comfort and your body's response.",
        whoFor: ["Chronic muscle tightness", "Joint restriction and stiffness", "Patients who prefer hands-on care"],
        expect: ["Targeted soft-tissue release", "Manual spinal and extremity mobilization", "At-home mobility guidance"],
        benefits: ["Deeper muscular release", "Immediate ease of movement", "Longer-lasting relief"],
    },
    {
        id: "wellness-care",
        testid: "service-card-wellness",
        title: "Wellness Care",
        tagline: "Proactive care for lifelong vitality",
        image: "https://images.unsplash.com/photo-1709979058427-4005f7c65154?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        overview:
            "Ongoing maintenance care that keeps your spine and nervous system performing at their best — before pain ever starts. Ideal for patients who want to stay ahead of stress, strain, and the demands of an active life.",
        whoFor: ["Preventative wellness seekers", "Post-recovery maintenance", "High-stress lifestyles"],
        expect: ["Scheduled wellness visits", "Lifestyle and ergonomics coaching", "Whole-body check-ins"],
        benefits: ["Fewer flare-ups and setbacks", "Sustained energy and sleep quality", "A resilient, adaptable body"],
    },
    {
        id: "corrective-exercises",
        testid: "service-card-exercises",
        title: "Corrective Exercises",
        tagline: "Retrain movement, rebuild strength",
        image: "https://images.unsplash.com/photo-1645005512942-a17817fb7c11?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        overview:
            "Customized corrective exercise programs that address the root cause of pain — not just the symptoms. Dr. Lane builds progressive movement protocols you can perform at home or in the gym.",
        whoFor: ["Recurring injuries", "Muscle imbalances and weakness", "Post-rehabilitation rebuilding"],
        expect: ["Movement screen and testing", "Personalized exercise program", "Technique coaching and progressions"],
        benefits: ["Stronger, balanced movement patterns", "Reduced re-injury risk", "Confidence in daily activity"],
    },
    {
        id: "sports-care",
        testid: "service-card-sports",
        title: "Sports Care",
        tagline: "Recover faster, perform stronger",
        image: "https://images.unsplash.com/photo-1709979058441-3cfbb2059a72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        overview:
            "Performance-focused chiropractic for athletes of every level across DFW. From weekend warriors to competitive athletes, care combines adjustments, soft-tissue therapy, and sport-specific recovery strategies.",
        whoFor: ["Competitive and recreational athletes", "Sports injuries and strains", "Performance optimization"],
        expect: ["Sport-specific assessment", "Recovery and return-to-play planning", "Performance mobility work"],
        benefits: ["Faster recovery between sessions", "Improved power and mobility", "Injury prevention strategies"],
    },
];

export const AUDIENCES = [
    {
        title: "Athletes",
        text: "Sport-specific adjustments and recovery protocols that keep you training, competing, and performing at your peak.",
        image: "https://images.unsplash.com/photo-1709979058441-3cfbb2059a72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        span: "lg:col-span-7",
    },
    {
        title: "Active Adults",
        text: "Stay ahead of the aches that come with busy, on-the-go DFW lifestyles — from the office to the weekend trail.",
        image: "https://images.unsplash.com/photo-1578730260596-4e06848029b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        span: "lg:col-span-5",
    },
    {
        title: "Families",
        text: "Gentle, age-appropriate care for every member of the family, building healthy movement habits for life.",
        image: null,
        span: "lg:col-span-4",
    },
    {
        title: "Chronic Pain",
        text: "Root-cause treatment plans for persistent pain — with measurable progress you can feel visit after visit.",
        image: null,
        span: "lg:col-span-4",
    },
    {
        title: "Preventative Wellness",
        text: "Proactive maintenance care that keeps your body resilient, adaptable, and ready for whatever comes next.",
        image: null,
        span: "lg:col-span-4",
    },
];

export const TESTIMONIALS = [
    {
        name: "Marcus T.",
        role: "Competitive Runner, Dallas",
        quote: "After months of hip pain, Dr. Lane had me back to full training in weeks. Her sports care approach is on another level.",
    },
    {
        name: "Priya S.",
        role: "Busy Mom of Three, Frisco",
        quote: "She treats our whole family with such patience and care. The kids actually look forward to their visits.",
    },
    {
        name: "James R.",
        role: "Chronic Back Pain Patient, Plano",
        quote: "Ten years of back pain, and this is the first care plan that actually addressed the cause. I move like a different person.",
    },
];
